import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getStockAccount, deleteStockAccount } from '../actions/StockAccountActions';
import { Pane, Heading, Button } from 'evergreen-ui';

import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import { Link } from 'react-router-dom';
import StockAccountInfoBlock from '../components/StockAccountInfoBlock';

class ViewStockAccount extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    
    async componentDidMount() {
        await this.props.dispatch(getStockAccount(this.id))
    }

    handleDelete = () => {
        this.props.dispatch(deleteStockAccount(this.id));
    }

    render() {
            
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/stock-accounts">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista furnizori
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge contul"
                            title="Confirmare stergere cont"
                            confirmLabel="Sterg definitiv contul"
                            message="Esti sigur ca vrei sa stergi contul?"/>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Cont - <strong>{this.props.stockAccount.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <StockAccountInfoBlock stockAccount={this.props.stockAccount}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        stockAccount: state.stockAccounts.current
    }
}

export default connect(mapStateToProps)(ViewStockAccount);